import { Popover as MuiPopover } from '@mui/material';
import React from 'react';
import { useStyles } from './Popover.styles';
function getReversedPosition(position) {
    switch (position) {
        case 'bottom':
            return 'top';
        case 'top':
            return 'bottom';
        case 'left':
            return 'right';
        case 'right':
            return 'left';
        default:
            return position;
    }
}
export function Popover(props) {
    const classes = useStyles(props);
    const { anchorElement, container, children, className, id, open, onClose, position, testid } = props;
    return (React.createElement(MuiPopover, { className: className, "data-testid": testid, id: id, open: open, anchorEl: anchorElement, container: container, onClose: onClose, anchorOrigin: {
            vertical: (['top', 'bottom'].includes(position) ? position : 'center'),
            horizontal: (['left', 'right'].includes(position) ? position : 'center'),
        }, transformOrigin: {
            vertical: (['top', 'bottom'].includes(position) ? getReversedPosition(position) : 'center'),
            horizontal: (['left', 'right'].includes(position) ? getReversedPosition(position) : 'center'),
        }, classes: {
            paper: classes.paper,
        }, PaperProps: {
            elevation: 24,
        } }, children));
}
//# sourceMappingURL=Popover.js.map